import { render } from "./ProcessPaiement.vue?vue&type=template&id=5251f220&ts=true"
import script from "./ProcessPaiement.vue?vue&type=script&lang=ts"
export * from "./ProcessPaiement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__